if (!customElements.get('ff-product-gallery')) {
  customElements.define('ff-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.assets = JSON.parse(this.querySelector('[data-gallery-assets]').textContent);
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-view]');
        if (button) this.show(button.dataset.view);
        if (this.swiped) { event.preventDefault(); this.swiped = false; return; }
        const zoom = event.target.closest('a[data-full]');
        if (zoom && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.opener = zoom;
          const image = this.dialog.querySelector('img');
          image.src = zoom.dataset.full;
          image.alt = zoom.querySelector('img').alt;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
      }, { signal: this.controller.signal });
      this.dialog.addEventListener('close', () => this.opener?.focus(), { signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        if (!event.target.matches('button[data-view]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...this.querySelectorAll('button[data-view]')];
        const current = buttons.indexOf(event.target);
        const next = buttons[(current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length];
        this.show(next.dataset.view);
        next.focus();
      }, { signal: this.controller.signal });
      const slides = this.querySelector('.ff-gallery__slides');
      slides.addEventListener('touchstart', event => { this.startX = event.changedTouches[0].clientX; this.startY = event.changedTouches[0].clientY; }, { passive: true, signal: this.controller.signal });
      slides.addEventListener('touchend', event => {
        const dx = event.changedTouches[0].clientX - this.startX;
        const dy = event.changedTouches[0].clientY - this.startY;
        if (Math.abs(dx) < 60 || Math.abs(dx) < Math.abs(dy)) return;
        const buttons = [...this.querySelectorAll('button[data-view]')];
        const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        this.swiped = true;
        this.show(buttons[(current + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length].dataset.view);
      }, { passive: true, signal: this.controller.signal });
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const size = String(data.variant.id) === '47496571519309' ? '500' : '250';
        for (const view of ['front', 'back']) {
          const slide = this.querySelector(`figure[data-view="${view}"]`);
          slide.querySelector('img').src = this.assets[size][view];
          slide.querySelector('img').alt = slide.querySelector('img').alt.replace(/(?:250|500) ml/, `${size} ml`);
          slide.querySelector('a').href = this.assets[size][`${view}Large`];
          slide.querySelector('a').dataset.full = this.assets[size][`${view}Large`];
          this.querySelector(`button[data-view="${view}"] img`).src = this.assets[size][view];
        }
        this.dataset.size = size;
        this.show('front');
      });
    }
    show(view) {
      this.querySelectorAll('figure[data-view]').forEach(slide => { slide.hidden = slide.dataset.view !== view; });
      this.querySelectorAll('button[data-view]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.view === view));
        if (button.dataset.view === view) this.querySelector('[data-gallery-status]').textContent = button.textContent.trim();
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.unsubscribe?.(); }
  });
}
